import BlockHero from './hero'

export default BlockHero
